import { render, staticRenderFns } from "./cancelReason.vue?vue&type=template&id=65d6846c&scoped=true&lang=html&"
import script from "./cancelReason.vue?vue&type=script&lang=js&"
export * from "./cancelReason.vue?vue&type=script&lang=js&"
import style0 from "./cancelReason.vue?vue&type=style&index=0&id=65d6846c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6846c",
  null
  
)

export default component.exports